import { useQuery } from 'react-query';

import { getProfile } from 'api/profile/getProfile';
import { profileSuccess } from 'slices/login/reducer';
import { useAppDispatch } from 'slices';

const useGetUser = () => {
  const dispatch = useAppDispatch();

  const { data, isLoading, refetch } = useQuery('profile', getProfile, {
    onSuccess(data) {
      dispatch(profileSuccess(data));
    },
  });

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useGetUser;
